import React from "react";
import { useIntl } from "react-intl";
import { useHelpTooltip } from "../../hooks/useHelpTooltip";
import { HelpTooltip } from "./HelpTooltip";
import styles from "./RecekAccordionLabel.module.css";
export var RecekAccordionLabel = function (_a) {
    var labelId = _a.labelId;
    var formatMessage = useIntl().formatMessage;
    var _b = useHelpTooltip(labelId), helpId = _b.helpId, hasHelp = _b.hasHelp;
    return (React.createElement("span", { className: styles.wrapper },
        formatMessage({ id: labelId }),
        hasHelp && (React.createElement(HelpTooltip, { id: "".concat(labelId, "-help"), textId: helpId, hasLabel: false }))));
};
